import { render, staticRenderFns } from "./exchange-popup.vue?vue&type=template&id=55829f9a&scoped=true&lang=pug&"
import script from "./exchange-popup.vue?vue&type=script&lang=js&"
export * from "./exchange-popup.vue?vue&type=script&lang=js&"
import style0 from "./exchange-popup.vue?vue&type=style&index=0&id=55829f9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55829f9a",
  null
  
)

export default component.exports